<template>
  <div class="zxglve-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="分类" prop="type">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable>
                <el-option v-for="item in typeList" :key="item.type" :label="item.label" :value="item.type" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加装修攻略</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="strategyList"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="封面图片"
                    align="left"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div height="30px">
                        <el-image :src="scope.row.imgUrl" :size="50"></el-image>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="标题"
                    width="200"
                    align="left"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="描述"
                    width="200"
                    align="left"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="分类"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.type === 0">定制攻略</span>
                      <span v-if="scope.row.type === 1">家装知识</span>
                      <span v-if="scope.row.type === 2">加盟指南</span>
                      <span v-if="scope.row.type === 3">企业资讯</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="views"
                    label="浏览量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="发布时间"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="200">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="封面图" prop="img">
          <SingleImg :key="imgKey" v-model="addForm.img" :oldurl="addForm.oldimgurl" />
        </el-form-item>
        <el-form-item label="分类" prop="type">
          <el-select v-model="addForm.type" style="width: 120px" filterable clearable>
            <el-option v-for="item in typeList" :key="item.type" :label="item.label" :value="item.type" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" maxlength="300" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="addForm.remark"
            maxlength="500"
            type="textarea"
            :rows="3"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="浏览量" prop="views">
          <el-input-number v-model="addForm.views" :precision="0" :min="1" :max="10000" size="medium" show-word-limit>
          </el-input-number>
        </el-form-item>
        <el-form-item label="详情" prop="content">
          <Tinymce v-model="addForm.content" v-if="dialogVisible"></Tinymce>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="btnLoading" @click="submitTemplate">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import Tinymce from '@/components/Tinymce/index'
import SingleImg from '@/components/upload/SingleImg'
import {
  addOrEditStrategy,
  deleteStrategy,
  getStrategyPC
} from '@/api/community'

export default {
  name: 'zxglve',
  computed: {
    user: getUser
  },
  components: {
    SingleImg,
    Tinymce
  },
  data() {
    return {
      imgKey: '',
      loading: false,
      remarkVisible: false,
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false,
      searchForm: {
        search: '',
        type: null
      },
      typeList: [{
        type: 0,
        label: '定制攻略'
      }, {
        type: 1,
        label: '家装知识'
      }, {
        type: 2,
        label: '加盟指南'
      }, {
        type: 3,
        label: '企业资讯'
      }],
      type: null,
      strategyList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      addForm: {
        img: null,
        oldimgurl: '',
        type: '',
        title: '',
        remark: '',
        content: '',
        time: '',
        views: null,
        id: null
      },
      addRules: {
        type: [{ required: true, message: '请选择分类', trigger: 'change' }],
        remark: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        img: [{ required: true, message: '请上传封面图', trigger: 'blur' }],
        content: [{ required: true, message: '请输入文本', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        views: [{ required: true, message: '请输入浏览量', trigger: 'blur' }]
      },
      title: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getData() { // 获取装修攻略
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search,
        type: this.searchForm.type
      }
      getStrategyPC(data).then(response => {
        this.strategyList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    addTemplate() {
      this.addForm.id = 0
      this.addForm.type = null
      this.addForm.title = ''
      this.addForm.remark = ''
      this.addForm.views = null
      this.addForm.img = null
      this.addForm.oldimgurl = null
      this.addForm.content = ''
      this.dialogTitle = '添加装修攻略'
      this.dialogVisible = true
      this.imgKey = new Date().getTime().toString()
    },
    editTemplate(row) {
      this.imgKey = new Date().getTime().toString()
      this.addForm.id = row.sid
      this.addForm.type = row.type
      this.addForm.title = row.title
      this.addForm.remark = row.remark
      this.addForm.views = row.views
      this.addForm.img = { imgid: row.imgid, imgUrl: row.imgUrl }
      this.addForm.oldimgurl = row.imgUrl
      this.addForm.content = row.content
      this.dialogTitle = '修改装修攻略'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此装修攻略吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteStrategy({ id: row.sid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTemplate() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              id: this.addForm.id,
              type: this.addForm.type,
              title: this.addForm.title,
              remark: this.addForm.remark,
              views: this.addForm.views,
              imgid: this.addForm.img.imgid,
              content: this.addForm.content
            }
            addOrEditStrategy(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zxglve-container {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode{
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .search-area{
        float: right;
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
